module.exports = __webpack_public_path__ + "static/media/cover.cd452615.png";